import { gql } from '@apollo/client'

export const GET_FACTORY_FILTER = gql`
  query FactoryFilters {
    aggregation(
      index: "pedidos_items_alias",
      query: {
        bool: {
          filter: [
            {
              exists: {
                field: "items.factory.keyword"
              }
            }
          ]
        }
      },
      aggs: {
        factories: {
          terms: {
            field: "items.factory.keyword",
            size: 10000,
            order: {
              _key: "asc"
            }
          }
        }
      }
    )
    {
      aggregations
    }
  }
`

export const GET_BRANDS_FILTER = gql`
  query BrandFilters($filters: JSON) {
    aggregation(
      index: "pedidos_items_alias",
      query: {
        bool: {
          filter: [
            {
              exists: {
                field: "items.factory"
              }
            }
          ]
        }
      },
      filters: $filters,
      aggs: {
        brands: {
          terms: {
            field: "items.brand",
            size: 2000,
            order: {
              _key: "asc"
            }
          }
        }
      }
    )
    {
      aggregations
    }
  }
`

export const GET_CLIENTS = gql`
  query ClientFilters($filters: JSON) {
    aggregation(
      index: "pedidos_items_alias",
      query: {
        bool: {
          filter: [
            {
              exists: {
                field: "items.factory"
              }
            }
          ]
        }
      },
      filters: $filters,
      aggs: {
        clients: {
          terms: {
            field: "client_id",
            size: 10,
            order: {
              _key: "asc"
            }
          }
        }
      }
    )
    {
      aggregations
    }
  }
`

export const GET_STATUS_FILTER = gql`
  query StatusFilters($filters: JSON) {
    aggregation(
      index: "pedidos_items_alias",
      filters: $filters,
      aggs: {
        status: {
          terms: {
            field: "new_statusTranslate.keyword",
            size: 10,
            order: {
              _key: "asc"
            }
          }
        }
      }
    )
    {
      aggregations
    }
  }
`

export const GET_REVENUE = gql`
  query GetRevenue($filters: JSON) {
    aggregation(
      index: "pedidos_items_alias",
      filters: $filters,
      aggs: {
        total: {
          sum: {
            field: "items.total"
          }
        }
      }
    )
    {
      aggregations
    }
  }
`

export const GET_ORDER_QUANTITY = gql`
  query GetOrderQuantity($filters: JSON) {
    aggregation(
      index: "pedidos_items_alias",
      query: {
        bool: {
          filter: [
            {
              exists: {
                field: "items.factory"
              }
            }
          ]
        }
      },
      filters: $filters,
      aggs: {
        ordersQuantity: {
          cardinality: {
            field: "id.keyword"
          }
        }
      }
    )
    {
      aggregations
    }
  }
`

export const GET_ITENS_QUANTITY = gql`
  query GetItensQuantity($filters: JSON) {
    aggregation(
      index: "pedidos_items_alias",
      query: {
        bool: {
          filter: [
            {
              exists: {
                field: "items.factory"
              }
            }
          ]
        }
      },
      filters: $filters,
      aggs: {
        itensQuantity: {
          sum: {
            field: "items.quantity"
          }
        }
      }
    )
    {
      aggregations
    }
  }
`

export const GET_REVENUE_BY_MONTH = gql`
  query GetItensQuantity($filters: JSON) {
    aggregation(
      index: "pedidos_items_alias",
      query: {
        bool: {
          filter: [
            {
              exists: {
                field: "items.factory"
              }
            }
          ]
        }
      },
      filters: $filters,
      aggs: {
        months: {
          date_histogram: {
            field: "created_at",
            interval: "month",
            time_zone: "-03:00"
          },
          aggs: {
            total: {
              sum: {
                field: "items.total"
              }
            }
          }
        }
      }
    )
    {
      aggregations
    }
  }
`

export const GET_BRANDS = gql`
  query BrandFilters($filters: JSON) {
    aggregation(
      index: "pedidos_items_alias",
      query: {
        bool: {
          filter: [
            {
              exists: {
                field: "items.factory"
              }
            }
          ]
        }
      },
      filters: $filters,
      aggs: {
        brands: {
          terms: {
            field: "items.brand",
            size: 10,
            order: {
              _count: "desc"
            }
          }
        }
      }
    )
    {
      aggregations
    }
  }
`

export const GET_STATUS = gql`
  query GetStatus($filters: JSON) {
    aggregation(
      index: "pedidos_items_alias",
      query: {
        bool: {
          filter: [
            {
              exists: {
                field: "items.factory"
              }
            }
          ]
        }
      },
      filters: $filters,
      aggs: {
        status: {
          terms: {
            field: "new_statusTranslate.keyword",
            size: 10,
            order: {
              _count: "desc"
            }
          }
        }
      }
    )
    {
      aggregations
    }
  }
`

export const GET_INCOME_SHARE_BY_CLIENT = gql`
  query GetStatus($filters: JSON) {
    aggregation(
      index: "pedidos_items_alias",
      query: {
        bool: {
          filter: [
            {
              exists: {
                field: "items.factory"
              }
            }
          ]
        }
      },
      filters: $filters,
      aggs: {
        brands: {
          terms: {
            field: "items.brand",
            size: 20,
            order: {
              _count: "desc"
            }
          },
          aggs: {
            clients: {
              terms: {
                field: "client_id",
                size: 10,
                min_doc_count: 0,
                exclude: "Outros",
                order: {
                  _key: "asc"
                }
              },
              aggs: {
                total: {
                  sum: {
                    field: "items.total"
                  }
                }
              }
            }
          }
        }
      }
    )
    {
      aggregations
    }
  }
`

export const GET_FACTORY_MONITORING = gql`
  query GetIndustryMonitoring($filters: IndustryMonitoringFilter) {
    industryMonitoring (
      filters: $filters
    ) {
      brand,
      device,
      items,
      deltaItems,
      averageValue,
      deltaAverageValue,
      orders,
      deltaOrders,
      income,
      deltaIncome
    }
  }
`
